import Vue from 'vue'
import Router from 'vue-router'

//導入路由
import login from '../views/login.vue'
import index from '../views/index.vue'
// import personnel_manage from '../views/personnel_manage/index.vue'
// import buy_records from '../views/buy_records/index.vue'
// import ride_records from '../views/ride_records/index.vue'

import airport_passenger_lists from "../views/airport_passenger_lists/index.vue";
import airport_declaration_lists from "../views/airport_declaration_lists/index.vue";

import store from '../commonality/vuex'
import axios from '../commonality/http'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      name: 'login',
      path: '/login',
      component: login,
      meta: {
        title: '穿梭巴士-管理系統',
        keepAlive: false, //是否緩存
        bodycolor: "#fff" //body顏色
      }
    },
    {
      name: 'login2',
      path: '/',
      component: login,
      meta: {
        title: '穿梭巴士-管理系統',
        keepAlive: false, //是否緩存
        bodycolor: "#fff" //body顏色
      }
    },
    {
      name: 'passenger_lists',
      path: '/passenger_lists',
      component: airport_passenger_lists,
      meta: {
        title: '穿梭巴士-管理系統',
        keepAlive: false, //是否緩存
        bodycolor: "#fff" //body顏色
      }
    },
    {
      name: 'declaration_lists',
      path: '/declaration_lists',
      component: airport_declaration_lists,
      meta: {
        title: '穿梭巴士-管理系統',
        keepAlive: false, //是否緩存
        bodycolor: "#fff" //body顏色
      }
    },
    // {
    //   path: '/panel',
    //   component: index,
    //   meta: {
    //     title: '穿梭巴士-管理系統',
    //     keepAlive: false, //是否緩存
    //     bodycolor: "#fff" //body顏色
    //   },
    //   children: [
    //     {
    //       name: 'personnel_manage',
    //       path: 'personnel_manage',
    //       component: personnel_manage,
    //       meta: {
    //         title: '穿梭巴士-管理系統',
    //         keepAlive: false, //是否緩存
    //         bodycolor: "#fff", //body顏色
    //         tabIndex: 0, //菜單索引
    //       },
    //     },
    //     {
    //       name: 'personnel_manage2',
    //       path: '/',
    //       component: personnel_manage,
    //       meta: {
    //         title: '穿梭巴士-管理系統',
    //         keepAlive: false, //是否緩存
    //         bodycolor: "#fff", //body顏色
    //         tabIndex: 0, //菜單索引
    //       },
    //     },
    //     {
    //       name: 'buy_records',
    //       path: 'buy_records',
    //       component: buy_records,
    //       meta: {
    //         title: '穿梭巴士-管理系統',
    //         keepAlive: false, //是否緩存
    //         bodycolor: "#fff", //body顏色
    //         tabIndex: 1, //菜單索引
    //       },
    //     },
    //     {
    //       name: 'ride_records',
    //       path: 'ride_records',
    //       component: ride_records,
    //       meta: {
    //         title: '穿梭巴士-管理系統',
    //         keepAlive: false, //是否緩存
    //         bodycolor: "#fff", //body顏色
    //         tabIndex: 2, //菜單索引
    //       },
    //     },
    //     // // 郵件
    //     // {
    //     //   path: 'email_index',
    //     //   name: '/email_index',
    //     //   component: email_index,
    //     //   meta: {
    //     //     title: '郵件群發',
    //     //     keepAlive: false, //是否緩存
    //     //     bodycolor: "#fff", //body顏色
    //     //   }
    //     // },
    //     // {
    //     //   path: 'edit_email',
    //     //   name: '/edit_email',
    //     //   component: edit_email,
    //     //   meta: {
    //     //     title: '編輯郵件',
    //     //     keepAlive: false, //是否緩存
    //     //     bodycolor: "#fff", //body顏色
    //     //   }
    //     // },
    //     // {
    //     //   path: 'email_detail',
    //     //   name: '/email_detail',
    //     //   component: email_detail,
    //     //   meta: {
    //     //     title: '郵件詳情',
    //     //     keepAlive: false, //是否緩存
    //     //     bodycolor: "#fff", //body顏色
    //     //   }
    //     // },
    //     // {
    //     //   path: 'inf_check_index',
    //     //   name: '/inf_check_index',
    //     //   component: inf_check_index,
    //     //   meta: {
    //     //     title: '旅行社資料審核',
    //     //     keepAlive: true, //是否緩存
    //     //     bodycolor: "#fff", //body顏色
    //     //     tabIndex: 0, //菜單索引
    //     //   }
    //     // },
    //     // {
    //     //   path: 'inf_check_details',
    //     //   name: '/inf_check_details',
    //     //   component: inf_check_details,
    //     //   meta: {
    //     //     title: '旅行社資料審核',
    //     //     keepAlive: false, //是否緩存
    //     //     bodycolor: "#fff", //body顏色
    //     //     tabIndex: 0, //菜單索引
    //     //   }
    //     // },
    //     // {
    //     //   path: 'charge_index',
    //     //   name: '/charge_index',
    //     //   component: charge_index,
    //     //   meta: {
    //     //     title: '旅行社充值管理',
    //     //     keepAlive: true, //是否緩存
    //     //     bodycolor: "#fff", //body顏色
    //     //     tabIndex: 1, //菜單索引
    //     //   }
    //     // },
    //     // {
    //     //   path: 'charge_submit',
    //     //   name: '/charge_submit',
    //     //   component: charge_submit,
    //     //   meta: {
    //     //     title: '旅行社充值錄入',
    //     //     keepAlive: false, //是否緩存
    //     //     bodycolor: "#fff", //body顏色
    //     //     tabIndex: 1, //菜單索引
    //     //   }
    //     // },
    //     // {
    //     //   path: 'charge_details',
    //     //   name: '/charge_details',
    //     //   component: charge_details,
    //     //   meta: {
    //     //     title: '旅行社充值審核',
    //     //     keepAlive: false, //是否緩存
    //     //     bodycolor: "#fff", //body顏色
    //     //     tabIndex: 1, //菜單索引
    //     //   }
    //     // },
    //     // {
    //     //   path: 'inf_index',
    //     //   name: '/inf_index',
    //     //   component: inf_index,
    //     //   meta: {
    //     //     title: '旅行社資料查詢',
    //     //     keepAlive: true, //是否緩存
    //     //     bodycolor: "#fff", //body顏色
    //     //     tabIndex: 2, //菜單索引
    //     //   }
    //     // },
    //     // {
    //     //   path: 'inf_detail',
    //     //   name: '/inf_detail',
    //     //   component: inf_detail,
    //     //   meta: {
    //     //     title: '旅行社資料查詢',
    //     //     keepAlive: false, //是否緩存
    //     //     bodycolor: "#fff", //body顏色
    //     //     tabIndex: 2, //菜單索引
    //     //   }
    //     // },
    //     // {
    //     //   path: 'order_index',
    //     //   name: '/order_index',
    //     //   component: order_index,
    //     //   meta: {
    //     //     title: '旅行社訂單查詢',
    //     //     keepAlive: true, //是否緩存
    //     //     bodycolor: "#fff", //body顏色
    //     //     tabIndex: 3, //菜單索引
    //     //   }
    //     // },
    //     // {
    //     //   path: 'order_detail',
    //     //   name: '/order_detail',
    //     //   component: order_detail,
    //     //   meta: {
    //     //     title: '旅行社訂單詳情',
    //     //     keepAlive: false, //是否緩存
    //     //     bodycolor: "#fff", //body顏色
    //     //     tabIndex: 3, //菜單索引
    //     //   }
    //     // },
    //     // {
    //     //   path: 'refund_index',
    //     //   name: '/refund_index',
    //     //   component: refund_index,
    //     //   meta: {
    //     //     title: '旅行社退款管理',
    //     //     keepAlive: true, //是否緩存
    //     //     bodycolor: "#fff", //body顏色
    //     //     tabIndex: 4, //菜單索引
    //     //   }
    //     // },
    //     // {
    //     //   path: 'refund_submit',
    //     //   name: '/refund_submit',
    //     //   component: refund_submit,
    //     //   meta: {
    //     //     title: '旅行社退款錄入',
    //     //     keepAlive: false, //是否緩存
    //     //     bodycolor: "#fff", //body顏色
    //     //     tabIndex: 4, //菜單索引
    //     //   }
    //     // },
    //     // {
    //     //   path: 'refund_details',
    //     //   name: '/refund_details',
    //     //   component: refund_details,
    //     //   meta: {
    //     //     title: '旅行社退款審核',
    //     //     keepAlive: false, //是否緩存
    //     //     bodycolor: "#fff", //body顏色
    //     //     tabIndex: 4, //菜單索引
    //     //   }
    //     // },
    //     // {
    //     //   path: 'charge_report_index',
    //     //   name: '/charge_report_index',
    //     //   component: charge_report_index,
    //     //   meta: {
    //     //     title: '旅行社充值報表',
    //     //     keepAlive: true, //是否緩存
    //     //     bodycolor: "#fff", //body顏色
    //     //     tabIndex: 5, //菜單索引
    //     //   }
    //     // },
    //     // {
    //     //   path: 'refund_report_index',
    //     //   name: '/refund_report_index',
    //     //   component: refund_report_index,
    //     //   meta: {
    //     //     title: '旅行社退款報表',
    //     //     keepAlive: true, //是否緩存
    //     //     bodycolor: "#fff", //body顏色
    //     //     tabIndex: 6, //菜單索引
    //     //   }
    //     // },
    //     // {
    //     //   path: 'account_flow',
    //     //   name: '/account_flow',
    //     //   component: account_flow,
    //     //   meta: {
    //     //     title: '旅行社賬戶流水',
    //     //     keepAlive: true, //是否緩存
    //     //     bodycolor: "#fff", //body顏色
    //     //     tabIndex: 7, //菜單索引
    //     //   }
    //     // },
    //   ]
    // }
  ]
});

router.beforeEach(async (to, from, next) => {
  //localStorage過期後，跳到登錄頁
  /*if(to.path!='/'){
      if(!window.localStorage.getItem('username')){
        next('/');
      }
  }*/

  //如果是登錄頁直接跳過
  if(to.name === 'login')
  {
    next()
    return
  }
  //vuex 沒有用戶信息
  if(Object.keys(store.state.userInfo).length <= 0)
  {
    let token = window.localStorage.getItem('token');

    if(!token)
    {
      next({name: 'login'})
      // next({path: '/login'})
      return
    }

    let response = await axios.post(Vue.prototype.IP + Vue.prototype.PATH + '/getuserinfo', {})

    //如果不成功
    if(response.data.code !== 'SUCCESS')
    {
      next({name: 'login'})
      // next({path: '/login'})
      return
    }

    let userInfo = response.data.responseData
    //保存管理員ID和名稱
    Vue.prototype.setCookie("admin_name", userInfo.name);//管理員名稱
    Vue.prototype.setCookie("accountId", userInfo.id)//管理員ID
    //保存用戶信息
    store.commit('setUserInfo', userInfo);
    //獲取 jwt
    store.commit('token', token);

    next();
    return
  }

  next();
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js